import { insertScript } from '../../../../../../Common/Resources/src_front/js/helper-functions/insertScript';

export const pushengage = () => {
    window._peq = window._peq || [];
    window._peq.push(['init']);

    insertScript('https://clientcdn.pushengage.com/core/b591bee4-3eb4-4e72-93f0-7912e4119ea9.js');
};
